import { render, staticRenderFns } from "./ImageBit.vue?vue&type=template&id=624c542d&"
import script from "./ImageBit.vue?vue&type=script&lang=js&"
export * from "./ImageBit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports